import { SplitFactory } from '@splitsoftware/splitio'

import {
  getSubjectKey,
  transformSplitToExperiment,
  treatmentsToCohortAllocations
} from '@godaddy/hivemind-common'

export default class SplitioWrapper {
  constructor ({
    splitioOptions,
    app,
    id,
    idType,
    splitioClient,
    splitioManager,
    preloadExists
  }) {
    splitioOptions.core.key = getSubjectKey({ id, idType })
    splitioOptions.storage = {
      type: 'LOCALSTORAGE',
      prefix: `${app}.${idType}`
    }

    let factory
    if (!splitioClient || !splitioManager) {
      factory = SplitFactory(splitioOptions)
    }

    if (!splitioClient) {
      splitioClient = factory.client()
    }

    if (!splitioManager) {
      splitioManager = factory.manager()
    }

    this._splitioClient = splitioClient
    this._splitioManager = splitioManager

    this._clientReady = new Promise(resolve =>
      this._splitioClient.on(
        preloadExists ? this._splitioClient.Event.SDK_READY_FROM_CACHE : this._splitioClient.Event.SDK_READY,
        resolve
      )
    )
    this._managerReady = new Promise(resolve =>
      this._splitioManager.on(
        preloadExists ? this._splitioManager.Event.SDK_READY_FROM_CACHE : this._splitioManager.Event.SDK_READY,
        resolve
      )
    )
    this._allReady = Promise.all([this._clientReady, this._managerReady])
  }

  get ready () {
    return this._allReady
  }

  getCohortAllocations ({ experiments = [], attributes = {} }) {
    const treatments = this._splitioClient.getTreatmentsWithConfig(experiments, attributes)

    return treatmentsToCohortAllocations(treatments)
  }

  getExperimentsById (experimentIds) {
    const splits = experimentIds.map(experimentId => this._splitioManager.split(experimentId))
    return experimentIds.reduce((mapping, experimentId, i) => {
      const split = splits[i]
      if (split !== null) {
        mapping[experimentId] = transformSplitToExperiment(split)
      }
      return mapping
    }, {})
  }

  getExperiments () {
    const splits = this._splitioManager.splits()
    return splits.reduce((mapping, split) => {
      mapping[split.name] = transformSplitToExperiment(split)
      return mapping
    }, {})
  }

  destroy () {
    return this._splitioClient.destroy().then(() => {
      delete this._splitioClient
    })
  }
}
